const ITEMS = [
  "Windows Server",
  "Linux",
  "Active Directory",
  "Azure Hybrid",
  "Hyper-V",
  "Microsoft 365",
  "Entra ID",
  "Firewalls & VPNs",
  "Backup & Continuidade",
  "Auditoria Técnica",
];

export default function Marquee() {
  return (
    <div className="bg-pale border-y border-line overflow-hidden" aria-hidden="false">
      <div className="relative py-4 overflow-hidden">
        <div className="flex w-max animate-marquee">
          {[0, 1].map((dup) => (
            <ul
              key={dup}
              aria-hidden={dup === 1 ? "true" : undefined}
              className="flex items-center shrink-0"
            >
              {ITEMS.map((item) => (
                <li key={`${dup}-${item}`} className="flex items-center">
                  <span className="font-mono text-xs sm:text-sm tracking-wide text-graphite/80 px-6 whitespace-nowrap">
                    {item}
                  </span>
                  <span className="w-1.5 h-1.5 rounded-full bg-techblue/70" />
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
}
